import React from 'react';
import { Modal, Button, LockboxModalHeader } from '../ui';
import GroupPlanMatrix from './GroupPlanMatrix';
import { typography } from '../../design-system/tokens';
import {
  GROUP_PLUS_UPSELL_HEADLINE,
  GROUP_PLUS_UPSELL_SUBLINE,
  GROUP_UPSELL_VARIANTS,
} from '../../constants/groupLimits';

export default function PlusLeagueUpsellSheet({
  open,
  onClose,
  variant = 'create_group',
  onStartTrial,
  checkoutLoading = false,
}) {
  const copy = GROUP_UPSELL_VARIANTS[variant] || GROUP_UPSELL_VARIANTS.create_group;

  return (
    <Modal
      open={open}
      onClose={onClose}
      accent="admin"
      size="md"
      header={(
        <LockboxModalHeader
          emoji="⭐"
          iconClassName="bg-violet-500/10 border-violet-500/20"
          title={copy.title}
          onClose={onClose}
        />
      )}
    >
      <div className="space-y-4">
        <p className={`${typography.microWide} text-violet-300`}>{GROUP_PLUS_UPSELL_HEADLINE}</p>
        <p className="text-sm text-gray-300 font-medium leading-relaxed">{copy.body}</p>
        <p className="text-xs text-gray-500 font-medium">{GROUP_PLUS_UPSELL_SUBLINE}</p>
        <GroupPlanMatrix compact />
        <ul className="space-y-1.5">
          {copy.bullets.map((line) => (
            <li key={line} className="text-xs text-gray-400 font-medium flex items-start gap-2">
              <span className="text-emerald-400 font-black shrink-0">✓</span>
              {line}
            </li>
          ))}
        </ul>
        <div className="flex flex-col sm:flex-row gap-2 pt-1">
          <Button
            type="button"
            variant="admin"
            fullWidth
            disabled={checkoutLoading}
            onClick={onStartTrial}
          >
            {checkoutLoading ? 'Redirecting…' : 'Start 7-Day Free Trial'}
          </Button>
          <Button type="button" variant="ghost" fullWidth onClick={onClose}>
            Maybe later
          </Button>
        </div>
      </div>
    </Modal>
  );
}
